// extracted by mini-css-extract-plugin
module.exports = {"bgmRoot":"index-bgmRoot-2Phfa","root":"index-root-2vMqu","audioName":"index-audioName-3L2KR","rotate":"index-rotate-3Ehw5"};